export async function initGsapAnimations() {
    if (typeof window === 'undefined') return;

    const { gsap } = await import('gsap');
    const ScrollTrigger = (await import('gsap/ScrollTrigger')).default;
    const ScrambleTextPlugin = (await import('gsap/ScrambleTextPlugin')).default;

    gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

    const animationMap: Record<string, gsap.TweenVars> = {
        '.fade-in': { opacity: 0, y: 40 },
        '.slide-up': { opacity: 0, y: 40 },
        '.slide-down': { opacity: 0, y: -40 },
        '.scale-in': { opacity: 0, scale: 0.8 },
        '.rotate-in': { opacity: 0, rotate: 7 },
        '.expand-in-out': { scale: 0.8, opacity: 0 },
    };

    const commonToVars: gsap.TweenVars = {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        rotate: 0,
        duration: 1,
        ease: 'power2.out',
    };

    Object.entries(animationMap).forEach(([selector, fromVars]) => {
        gsap.utils.toArray<HTMLElement>(selector).forEach((el) => {
            gsap.fromTo(
                el,
                fromVars,
                {
                    ...commonToVars,
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 80%',
                        end: 'bottom 20%',
                        toggleActions: 'play reverse play reverse',
                    },
                }
            );
        });
    });

    gsap.utils.toArray<HTMLElement>('.scramble-text').forEach((el) => {
        const finalText = el.dataset.text || el.textContent || "Text";

        gsap.to(el, {
            duration: 2,
            scrambleText: {
                text: finalText,
                chars: 'ABOPQRSTUCDEFGHIJKLMN',
                revealDelay: 0.05,
                speed: 0.4,
            },
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleActions: 'play none none none',
            },
        });
    });

    // Return a cleanup function to kill all ScrollTriggers
    return () => {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        gsap.globalTimeline.clear(); // Clear all animations
    };
}
